module.exports = __webpack_public_path__ + "static/media/wechatQR.be708020.jpg";